module.exports = __webpack_public_path__ + "media/images/application2/AppErrors__img-e38b8e6b43cbf6b230f9521aaaf9f304.svg";